import { useEffect, useState, useRef, ReactElement } from "react";
import styled from "styled-components";
import {
	AUA,
	Payment,
	PaymentMethod,
	CoorporateScheme,
	PaymentMethodScheme,
	UserScheme,
	ErrorScheme,
	Subscription,
	ProductScheme,
	Track,
	User,
	Product,
	ChallengeScheme,
	Challenge,
	SubscriptionScheme,
} from "client-v2";
import {
	loadStripe,
	PaymentRequest,
	PaymentRequestPaymentMethodEvent,
	SetupIntent,
} from "@stripe/stripe-js";
import Stripe from "stripe";
import ReactPixel from "react-facebook-pixel";
import SectionContainer from "../../container/SectionContainer";
import PaycardCell from "../../cell/PaycardCell";
import {
	Text,
	Payout,
	Modal,
	Input,
	ColorV2,
} from "@adoptaunabuelo/react-components";
import {
	User as UserIcon,
	Landmark,
	Lock,
	CreditCard,
	Check,
} from "lucide-react";
import PaycardLogo from "../../../assets/logo/Paycard";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import UpdateSubscriptionModal from "../../modal/UpdateSubscriptionModal";
import { useNavigate } from "react-router";

const Cell = styled.div<{ $isSelected?: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 12px;
	cursor: pointer;
	border-radius: 16px;
	z-index: 2;
	background-color: ${(props) =>
		props.$isSelected ? ColorV2.surface.primarySoft : "white"};
	border: ${(props) =>
		props.$isSelected ? `2px solid ${ColorV2.border.primary}` : "none"};
	&:hover {
		background-color: ${ColorV2.surface.neutralSoft};
	}
`;
const Col = styled.div`
	display: flex;
	flex-direction: column;
`;
const PaycardContainer = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 16px;
	max-height: 100%;
	overflow-y: scroll;
	border: 1px solid ${ColorV2.border.neutralSoft};
`;
const NewPaycardContainer = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 0px 0px 16px 16px;
	max-height: 100%;
	overflow-y: scroll;
	background-color: ${ColorV2.surface.background};
	padding: 32px 16px 16px;
	margin-top: -16px;
`;
const ButtonChildren = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
`;
const Selector = styled.div<{ $selected?: boolean; color?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 22px;
	width: 22px;
	border-radius: 100px;
	background-color: ${(props) =>
		props.$selected
			? props.color
				? props.color
				: ColorV2.surface.primary
			: "transparent"};
	border: ${(props) =>
		props.$selected
			? "2px solid " +
				(props.color ? props.color : ColorV2.surface.primary)
			: "2px solid " +
				(props.color
					? props.color + "1A"
					: ColorV2.border.neutralSoft)};
`;

const PaymentMethodStep = (
	props: Props &
		(
			| {
					product: ProductScheme;
					imageAuth?: boolean;
					shopProduct?: undefined;
					shipping?: undefined;
					isSubscriptor?: undefined;
					subscription?: SubscriptionScheme;
					canEdit?: undefined;
					challenge?: undefined;
					amount?: undefined;
					shippingAddress?: undefined;
			  }
			| {
					product?: undefined;
					imageAuth?: boolean;
					shopProduct?: undefined;
					shipping?: undefined;
					isSubscriptor?: undefined;
					subscription?: undefined;
					canEdit: "sepa" | "card";
					challenge?: undefined;
					amount?: undefined;
					shippingAddress?: undefined;
			  }
			| {
					product?: ProductScheme;
					imageAuth?: boolean;
					shopProduct?: undefined;
					shipping?: undefined;
					isSubscriptor?: undefined;
					subscription?: undefined;
					canEdit?: undefined;
					challenge: ChallengeScheme;
					amount?: number;
					shippingAddress?: undefined;
			  }
			| {
					product?: undefined;
					imageAuth?: boolean;
					shopProduct: ProductScheme;
					shipping: number;
					isSubscriptor: boolean;
					subscription?: undefined;
					canEdit?: undefined;
					challenge?: undefined;
					amount?: undefined;
					shippingAddress: {
						route: string;
						routeNumber?: string;
						routeInfo?: string;
						city?: string;
						zipCode: string;
						country: string;
					};
			  }
		),
) => {
	const payout = useRef<any>(null);
	const modal = useRef<any>(null);
	const stripeKey = AUA.getStripeKey();
	const navigate = useNavigate();

	const appLocation = useSelector((state: State) => state.location.location);
	const [paymentMethods, setPaymentMethods] = useState<PaymentMethodScheme[]>(
		[],
	);
	const [selectedPaycard, setSelectedPaycard] = useState<
		PaymentMethodScheme | undefined
	>(undefined);
	const [paymentIntent, setPaymentIntent] = useState<
		Stripe.PaymentIntent | undefined
	>(undefined);
	const [setupIntent, setSetupIntent] = useState<SetupIntent | undefined>(
		undefined,
	);
	const [showAdd, setShowAdd] = useState(false);
	const [confirmUrl, setConfirmUrl] = useState<string | undefined>(undefined);
	const [showModal, setShowModal] = useState(false);
	const [paymentRequest, setPaymentRequest] = useState<
		PaymentRequest | undefined
	>(undefined);
	const [canUseApplePay, setCanUseApplePay] = useState<
		"apple_pay" | "google_pay" | undefined
	>(undefined);
	const [applePaySelection, setApplePaySelection] = useState<
		"apple_pay" | "google_pay" | undefined
	>(undefined);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [IBAN, setIBAN] = useState<{
		account: string | undefined;
		name: string | undefined;
	}>({
		account: undefined,
		name: undefined,
	});
	const [canUseStripe, setCanUseStripe] = useState(false);
	const [currencyPrice, setCurrencyPrice] = useState("");
	const [currentSubscription, setCurrentSubscription] = useState<
		SubscriptionScheme | undefined
	>(undefined);
	const [showUpdateSubscription, setShowUpdateSubscription] = useState(false);

	const getCanUseStripe = () => {
		if (props.canEdit) {
			if (props.canEdit === "sepa") {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
			// if (props.challenge && props.challenge.type !== "signature") {
			// 	return true;
			// } else {
			// 	if (appLocation && !appLocation.currency.hasSEPA) {
			// 		return true;
			// 	} else {
			// 		if (props.product?.charge === "unique") {
			// 			return true;
			// 		} else return false;
			// 	}
			// }
		}
	};

	window.addEventListener(
		"message",
		function (ev) {
			if (ev.data === "3DS-authentication-complete" && showModal) {
				modal.current.close();
			}
		},
		false,
	);

	useEffect(() => {
		const temp = getCanUseStripe();
		setCanUseStripe(temp);
		const price = getCurrencyPrice();
		getPaymentMethods(temp);

		if (props.product) {
			//Check if the user is a subscriptior already
			setLoading(true);
			Subscription.get({
				userId: props.user.objectId,
				state: ["active", "paused", "trialing"],
				include: ["Product"],
				page: 0,
				limit: 1,
			})
				.then((result) => {
					if (result.data && result.data.length > 0) {
						setCurrentSubscription(result.data[0]);
						const timer = setTimeout(() => {
							setShowUpdateSubscription(true);
							setLoading(false);
						}, 1000);

						return () => clearTimeout(timer);
					} else {
						setLoading(false);
					}
				})
				.catch((e) => {
					console.error(e);
					setLoading(false);
				});
		}

		//Load Apple Pay and Google Pay
		if ((props.product || props.challenge || props.shopProduct) && temp) {
			loadStripe(stripeKey).then((stripe) => {
				if (stripe) {
					const currency = props.shopProduct
						? "eur"
						: appLocation
							? appLocation.currency.name
							: "eur";
					const paymentRequest = stripe.paymentRequest({
						currency: currency,
						country: appLocation ? appLocation.country_code : "ES",
						total: {
							label: "Donación Adopta Un Abuelo",
							amount: price * 100,
						},
						requestPayerName: false,
						requestPayerEmail: false,
					});
					setPaymentRequest(paymentRequest);
					paymentRequest
						.canMakePayment()
						.then((result) => {
							if (
								result &&
								(result.applePay || result.googlePay)
							) {
								setCanUseApplePay(
									result.applePay
										? "apple_pay"
										: result.googlePay
											? "google_pay"
											: undefined,
								);
								setShowAdd(false);
							}
						})
						.catch((e) => console.log(e));
				}
			});
		} else {
			setCanUseApplePay(undefined);
		}
	}, [props.canEdit, props.product, props.challenge]);

	const getPaymentMethods = (canUseStripe: boolean) => {
		setLoading(true);
		PaymentMethod.get({
			userId: props.user.objectId,
			types: canUseStripe ? ["paycard"] : ["sepa_debit"],
		})
			.then((result) => {
				setLoading(false);
				setPaymentMethods(result.data);
				if (result.data.length > 0) {
					setShowAdd(false);
					result.data.map((item) => {
						if (item.default) {
							setSelectedPaycard(item);
						}
					});
				} else {
					setShowAdd(true);
				}
			})
			.catch((e: ErrorScheme) => {
				setLoading(false);
				props.onFinish({ error: e.message });
			});
	};

	const getCurrencyPrice = () => {
		const tempLanguage = appLocation?.language || "es-ES";
		const tempCurrencyName = props.shopProduct
			? "EUR"
			: appLocation?.currency.name.toUpperCase() || "EUR";
		const product = props.product || props.shopProduct;
		const shipping = props.shipping || 0;
		const tax = props.shopProduct ? 1.21 : 1;
		if (product) {
			if (product.data) {
				const price = product.data[tempCurrencyName as any];
				const totalPrice =
					((price
						? props.isSubscriptor
							? price.ambassadorPrice || price.price
							: price.price
						: product.price) +
						shipping) *
					tax;
				const hasDecimals = parseFloat(totalPrice.toFixed(2)) % 1 !== 0;
				const tempPrice = new Intl.NumberFormat(tempLanguage, {
					style: "currency",
					currency: tempCurrencyName,
					minimumFractionDigits: hasDecimals ? 2 : 0,
					maximumFractionDigits: hasDecimals ? 2 : 0,
				}).format(totalPrice);
				setCurrencyPrice(tempPrice);
				return parseFloat(totalPrice.toFixed(2));
			} else {
				const tempPrice = new Intl.NumberFormat(tempLanguage, {
					style: "currency",
					currency: tempCurrencyName,
					maximumFractionDigits: 0,
				}).format(product.price + shipping);
				setCurrencyPrice(tempPrice);
				return parseFloat((product.price + shipping).toFixed(2));
			}
		} else {
			return 0;
		}
	};

	//1- Check if is a payment method update or a subscription init. Generate the new Payment Method if needed and go to step 2
	const onNextClick = async () => {
		setLoading(true);
		//Check if is a new IBAN
		if (IBAN.account && IBAN.name) {
			//check IBAN
			const ibanRegex =
				/^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/;
			const ibanAccount = IBAN.account
				.replace(/\s/g, "")
				.replace("-", "")
				.toUpperCase();
			if (ibanRegex.test(ibanAccount)) {
				//Save the payment method
				PaymentMethod.initSetupIntent({
					userId: props.user.objectId,
					IBAN: ibanAccount,
					name: IBAN.name,
				})
					.then((result) => {
						const paymentMethod =
							result.data as PaymentMethodScheme;
						if (props.canEdit) {
							getPaymentMethods(canUseStripe);
						} else {
							if (props.subscription) updateSubscription();
							else initSubscription(paymentMethod.objectId);
						}
					})
					.catch((e: ErrorScheme) => {
						setLoading(false);
						props.onFinish({ error: e.message });
					});
			} else {
				setLoading(false);
				props.onFinish({
					error: "Parece que el número de cuenta que has introducido no es correcto.",
				});
			}
		} else {
			const generatedPaymentMethod =
				await payout.current?.getPaymentMethod();

			//Use Apple Pay or Google Pay
			if (applePaySelection && paymentRequest) {
				paymentRequest.show();
				paymentRequest.on("paymentmethod", async (ev) => {
					redirectPayment(ev.paymentMethod.id, ev);
				});
				paymentRequest.on("cancel", () => {
					setLoading(false);
				});
			}
			//Use the new added paycard
			else if (generatedPaymentMethod) {
				if (props.canEdit) {
					PaymentMethod.initSetupIntent({
						userId: props.user.objectId,
						cardId: generatedPaymentMethod.id,
						redirectUrl: window.location.origin + "/card-success",
					})
						.then((result) => {
							//Check if 3d secure needed
							const setupIntent = result.data as SetupIntent;
							confirmSetupIntent(setupIntent);
						})
						.catch((e: ErrorScheme) => {
							setLoading(false);
							props.onFinish({ error: e.message });
						});
				} else {
					redirectPayment(generatedPaymentMethod.id);
				}
			}
			//Use an old selected paycard
			else if (selectedPaycard) {
				redirectPayment(selectedPaycard.objectId);
			} else {
				setLoading(false);
				props.onFinish({
					error: "Debes seleccionar un método de pago antes de continuar",
				});
			}
		}
	};

	//1.2 - Redirect payment to proper progress
	const redirectPayment = (
		paymentMethodId: string,
		paymentRequestEvent?: PaymentRequestPaymentMethodEvent,
	) => {
		if (props.challenge && props.challenge.type !== "signature")
			registerToChallenge(paymentMethodId, paymentRequestEvent);
		else if (props.subscription) updateSubscription();
		else if (props.shopProduct)
			buyProduct(paymentMethodId, paymentRequestEvent);
		else if (!props.canEdit)
			initSubscription(paymentMethodId, paymentRequestEvent);
	};

	//2- Init the subscription or payment intent. If need to verify the payment intent, go to step 3. If not, go to step 5
	const initSubscription = async (
		paymentMethodId: string,
		paymentRequestEvent?: PaymentRequestPaymentMethodEvent,
	) => {
		if (props.product) {
			if (props.product.type === "event") {
				registerToEvent(
					props.product,
					paymentMethodId,
					paymentRequestEvent,
				);
			} else if (props.product.charge === "unique") {
				Track.event({
					event: "donation payment intent",
					user: props.user,
					params: {
						Product: "one-off",
						amount: props.product.price,
						view: props.view,
						Paycard: selectedPaycard?.brand,
					},
				});
				Payment.initPaymentIntent({
					userId: props.user.objectId,
					amount: props.product.price,
					currency: appLocation ? appLocation.currency.name : "eur",
					redirectUrl: window.location.origin + "/card-success",
					paymentMethod: paymentMethodId,
				})
					.then((result) => {
						//Check if 3d secure needed
						if (result.data.status === "requires_action") {
							confirmPaymentIntent(result.data);
						} else {
							onPaymentIntentConfirmed(
								undefined,
								paymentRequestEvent,
							);
						}
					})
					.catch((e: ErrorScheme) => {
						onPaymentIntentConfirmed(
							e.message,
							paymentRequestEvent,
						);
					});
			} else {
				//Track on mixpanel
				Track.event({
					event: "donation payment intent",
					user: props.user,
					params: {
						Product: props.product.objectId,
						amount: props.product.price,
						view: props.view,
					},
				});

				const initDate = dayjs().add(1, "month").startOf("month");
				Subscription.create({
					userId: props.user.objectId,
					productId: props.product.objectId,
					paymentMethod: paymentMethodId,
					currency: appLocation ? appLocation.currency.name : "eur",
					redirectUrl: window.location.origin + "/card-success",
					initDate: canUseStripe ? undefined : initDate.toDate(),
				})
					.then((result) => {
						const tempPaymentIntent: any = result.data;
						if (tempPaymentIntent.id) {
							confirmPaymentIntent(
								result.data as Stripe.PaymentIntent,
								paymentRequestEvent,
							);
						} else {
							onPaymentIntentConfirmed(
								undefined,
								paymentRequestEvent,
							);
						}
					})
					.catch((e: ErrorScheme) => {
						onPaymentIntentConfirmed(
							e.message,
							paymentRequestEvent,
						);
					});
			}
		}
	};

	const registerToChallenge = async (
		paymentMethod: string,
		paymentRequestEvent?: PaymentRequestPaymentMethodEvent,
	) => {
		if (props.challenge && props.amount) {
			setLoading(true);
			Track.event({
				event: "donation payment intent",
				user: props.user,
				params: {
					Product: "one-off",
					amount: props.amount,
					view: props.view,
				},
			});

			Challenge.initPaymentIntent(props.challenge.objectId, {
				userId: props.user.objectId,
				amount: props.amount,
				currency: appLocation ? appLocation.currency.name : "eur",
				paymentMethod: paymentMethod,
				redirectUrl: window.location.origin + "/card-success",
			})
				.then((result) => {
					const tempPaymentIntent: any = result.data;
					if (tempPaymentIntent.id) {
						confirmPaymentIntent(
							result.data as Stripe.PaymentIntent,
							paymentRequestEvent,
						);
					} else {
						onPaymentIntentConfirmed(
							undefined,
							paymentRequestEvent,
						);
					}
				})
				.catch((e: ErrorScheme) => {
					onPaymentIntentConfirmed(e.message, paymentRequestEvent);
				});
		}
	};

	const registerToEvent = async (
		product: ProductScheme,
		paymentMethodId?: string,
		paymentRequestEvent?: PaymentRequestPaymentMethodEvent,
	) => {
		setLoading(true);
		Track.event({
			event: "event register intent",
			user: props.user,
			params: {
				Product: product.objectId,
				amount: product.price,
				view: props.view,
			},
		});
		Product.initRegister(product.objectId, {
			userId: props.user.objectId,
			currency: appLocation ? appLocation.currency.name : "eur",
			redirectUrl: window.location.origin + "/card-success",
			paymentMethod: paymentMethodId ? paymentMethodId : undefined,
			imageAuth: props.imageAuth || false,
		})
			.then((result) => {
				if (product.price !== 0) {
					//Check if 3d secure needed
					const paymentIntent = result.data as Stripe.PaymentIntent;
					if (
						paymentIntent.status === "processing" ||
						paymentIntent.status === "succeeded"
					)
						onPaymentIntentConfirmed(
							undefined,
							paymentRequestEvent,
						);
					else
						confirmPaymentIntent(
							paymentIntent,
							paymentRequestEvent,
						);
				} else {
					onPaymentIntentConfirmed();
				}
			})
			.catch((error: ErrorScheme) => {
				onPaymentIntentConfirmed(error.message, paymentRequestEvent);
			});
	};

	const updateSubscription = () => {
		if (props.product) {
			//Track on mixpanel
			Track.event({
				event: "donation update init",
				user: props.user,
				params: {
					Product: props.product.objectId,
					amount: props.product.price,
					view: props.view,
					currency: appLocation
						? appLocation.currency.name.toUpperCase()
						: "EUR",
				},
			});

			if (props.subscription) {
				Subscription.set(props.subscription.objectId, {
					productId: props.product.objectId,
				})
					.then((result) => {
						onPaymentIntentConfirmed();
					})
					.catch((e) => {
						onPaymentIntentConfirmed(e.message);
					});
			} else if (currentSubscription) {
				Subscription.set(currentSubscription.objectId, {
					productId: props.product.objectId,
				})
					.then((result) => {
						onPaymentIntentConfirmed();
					})
					.catch((e) => {
						onPaymentIntentConfirmed(e.message);
					});
			}
		}
	};

	const buyProduct = (
		paymentMethod: string,
		paymentRequestEvent?: PaymentRequestPaymentMethodEvent,
	) => {
		if (props.shopProduct) {
			setLoading(true);
			Track.event({
				event: "shop product payment intent",
				user: props.user,
				params: {
					Product: props.shopProduct.objectId,
					amount: props.shopProduct.price,
					view: props.view,
				},
			});
			Product.shop(props.shopProduct.objectId, {
				userId: props.user.objectId,
				price: parseFloat(currencyPrice),
				currency: "eur",
				redirectUrl: "https://adoptaunabuelo.org/card-success",
				paymentMethod: paymentMethod,
				shippingAddress: props.shippingAddress,
			})
				.then((result) => {
					const tempPaymentIntent: any = result.data;
					if (tempPaymentIntent.id) {
						confirmPaymentIntent(
							result.data as Stripe.PaymentIntent,
							paymentRequestEvent,
						);
					} else {
						onPaymentIntentConfirmed(
							undefined,
							paymentRequestEvent,
						);
					}
				})
				.catch((e: ErrorScheme) => {
					onPaymentIntentConfirmed(e.message, paymentRequestEvent);
				});
		}
	};

	//3- Open modal to confirm payment intent in needed. If not, go to step 5
	const confirmPaymentIntent = async (
		paymentIntent: Stripe.PaymentIntent,
		ev?: PaymentRequestPaymentMethodEvent,
	) => {
		setPaymentIntent(paymentIntent);
		if (paymentIntent.status === "requires_action") {
			if (
				paymentIntent.next_action &&
				paymentIntent.next_action.redirect_to_url &&
				paymentIntent.next_action.redirect_to_url.url
			) {
				setConfirmUrl(paymentIntent.next_action.redirect_to_url.url);
				setShowModal(true);
			}
		} else {
			onPaymentIntentConfirmed(undefined, ev);
		}
	};

	const confirmSetupIntent = async (setupIntent: SetupIntent) => {
		setSetupIntent(setupIntent);
		if (setupIntent.status === "requires_action") {
			if (
				setupIntent.next_action &&
				setupIntent.next_action.redirect_to_url &&
				setupIntent.next_action.redirect_to_url.url
			) {
				setConfirmUrl(setupIntent.next_action.redirect_to_url.url);
				setShowModal(true);
			}
		} else {
			onSetupIntentConfirmed();
		}
	};

	//4- On confirmation modal closed. Review payment intent status
	const onConfirmModalClose = async () => {
		if (paymentIntent) {
			setShowModal(false);
			Payment.finishPaymentIntent(paymentIntent.id)
				.then((result) => {
					if (
						result.data.status === "succeeded" ||
						result.data.status === "processing"
					) {
						onPaymentIntentConfirmed();
					} else {
						onPaymentIntentConfirmed(
							"Parece que hay un error con tus datos. Comprueba que has añadido todo de manera correcta.",
						);
					}
				})
				.catch((error: ErrorScheme) => {
					onPaymentIntentConfirmed(error.message);
				});
		} else {
			setLoading(false);
		}
	};

	//5- On confirmation finished.
	const onPaymentIntentConfirmed = (
		error?: string,
		ev?: PaymentRequestPaymentMethodEvent,
	) => {
		const product = props.product || props.shopProduct;
		if (product || props.challenge) {
			if (error) {
				if (product?.type === "event") {
					//Track on mixpanel
					Track.event({
						event: "event register failed",
						user: props.user,
						params: {
							Product: product.objectId,
							amount: product.price,
							view: props.view,
						},
					});
				} else if (product?.type === "shop") {
					//Track on mixpanel
					Track.event({
						event: "shop product purchase failed",
						user: props.user,
						params: {
							Product: product.objectId,
							amount: product.price,
							view: props.view,
						},
					});
				} else {
					//Track on mixpanel
					Track.event({
						event: "donation activation failed",
						user: props.user,
						params: {
							Product: product
								? product.charge === "unique"
									? "one-off"
									: product.objectId
								: "unique",
							amount: product ? product.price : props.amount,
							view: props.view,
							error: error,
						},
					});
				}

				if (ev) ev.complete("fail");

				setLoading(false);
				props.onFinish({
					error: error,
				});
			} else {
				if (product?.type === "event") {
					//Track on mixpanel
					Track.event({
						event: "event register done",
						user: props.user,
						params: {
							Product: product.objectId,
							amount: product.price,
							view: props.view,
						},
					});
				} else if (product?.type === "shop") {
					Track.event({
						event: "shop product purchase done",
						user: props.user,
						params: {
							Product: product.objectId,
							amount: product.price,
							view: props.view,
						},
					});
				} else {
					//Track on Facebook
					const trackTitle = product
						? product.charge === "annually"
							? "SocioAnual"
							: product.charge === "monthly"
								? "SocioMensual"
								: "SocioPuntual"
						: "SocioPuntual";
					const customerType = product
						? product.charge === "annually"
							? "Anual"
							: product.charge === "monthly"
								? "Mensual"
								: "Puntual"
						: "Puntual";
					ReactPixel.trackCustom(trackTitle, {
						value: product ? product.price : props.amount,
						currency: appLocation
							? appLocation.currency.name
							: "eur",
						product_id: product ? product.objectId : "Puntual",
						product_name: product ? product.title : "Puntual",
						customer_type: customerType,
					});

					if (props.subscription || currentSubscription) {
						//Track on mixpanel
						Track.event({
							event: "donation update done",
							user: props.user,
							params: {
								Product: product?.objectId,
								amount: product?.price,
								view: props.view,
								currency: appLocation
									? appLocation.currency.name.toUpperCase()
									: "EUR",
							},
						});
					} else {
						//Track on mixpanel
						Track.event({
							event: "donation activation done",
							user: props.user,
							params: {
								Product: product
									? product.charge === "unique"
										? "one-off"
										: product.objectId
									: "one-off",
								amount: product ? product.price : props.amount,
								view: props.view,
								currency: appLocation
									? appLocation.currency.name.toUpperCase()
									: "EUR",
							},
						});
					}
				}
				const transactionId = dayjs().format(
					props.user.objectId + "-mm:ss-DD/MM/YYYY",
				);
				Track.charge(
					transactionId,
					product
						? {
								objectId: product.objectId,
								name: product.title,
								price: product.price,
								currency: appLocation
									? appLocation.currency.name.toUpperCase()
									: "EUR",
							}
						: {
								objectId: "unique",
								name: "Pago único",
								price: props.amount ? props.amount : 0,
								currency: appLocation
									? appLocation.currency.name.toUpperCase()
									: "EUR",
							},
				);

				if (ev) {
					ev.complete("success");
				}

				//Update user
				User.set(props.user.objectId, {
					internalData: {
						tags: "payment-donation",
					},
				});

				setLoading(false);
				setSuccess(true);
			}
		}
	};

	const onSetupIntentConfirmed = () => {
		setShowModal(false);
		setLoading(false);
		setShowAdd(false);
		getPaymentMethods(canUseStripe);
	};

	const onPaymentMethodClick = async (paymentMethod: PaymentMethodScheme) => {
		setLoading(true);
		PaymentMethod.setDefault(paymentMethod.objectId, {
			userId: props.user.objectId,
		})
			.then((result) => {
				setLoading(false);
				getPaymentMethods(canUseStripe);
			})
			.catch((e: ErrorScheme) => {
				setLoading(false);
				props.onFinish({ error: e.message });
			});
	};

	return (
		<SectionContainer
			title={
				showAdd
					? "Añade un método de pago"
					: "Selecciona un método de pago"
			}
			protectedDonation={
				props.view === "pack"
					? undefined
					: props.view === "challenge"
						? "challenge"
						: props.view === "birthday"
							? "birthday"
							: "donation"
			}
			buttonProps={
				props.canEdit && !showAdd && !props.paymentIntent
					? undefined
					: {
							style: {
								backgroundColor: success
									? ColorV2.surface.green
									: applePaySelection
										? "black"
										: ColorV2.surface.primary,
								width: props.Footer ? "fit-content" : "100%",
							},
							LeftView: props.Footer,
							children: (
								<ButtonChildren>
									<Lock height={20} width={20} />
									{applePaySelection ? (
										<>
											{props.shopProduct
												? "Pagar con"
												: "Donar con"}
											<PaycardLogo
												brand={
													applePaySelection +
													"_button"
												}
											/>
										</>
									) : props.subscription ? (
										"Actualizar mi donación"
									) : props.shopProduct ? (
										"Comprar"
									) : props.product ? (
										"Donar " +
										currencyPrice +
										(props.product.charge === "monthly"
											? " al mes"
											: props.product.charge ===
												  "annually"
												? " al año"
												: "")
									) : props.challenge &&
									  props.challenge.type !== "signature" ? (
										"Donar " +
										props.amount +
										(appLocation
											? appLocation.currency.symbol
											: "€")
									) : (
										"Guardar"
									)}
								</ButtonChildren>
							),
							loading: loading,
							success: success,
							backgroundColor: props.Footer
								? ColorV2.surface.background
								: "white",
							subtitle:
								props.product &&
								props.product.charge !== "unique"
									? `Tu donación se renovará automaticamente cada ${
											props.product.charge === "annually"
												? "año"
												: "mes"
										}. Puedes cancelarla en cualquier momento.`
									: undefined,
							onSuccess: () => {
								setSuccess(false);
								props.onFinish({ data: "ok" });
							},
							onClick: onNextClick,
						}
			}
		>
			{props.product && currentSubscription && (
				<UpdateSubscriptionModal
					isVisible={showUpdateSubscription}
					product={props.product}
					subscription={currentSubscription}
					onSubmit={() => {
						setShowUpdateSubscription(false);
						setLoading(true);
						updateSubscription();
					}}
					onClose={() => {
						setShowUpdateSubscription(false);
						navigate(-1);
					}}
				/>
			)}
			<Modal
				type="web"
				contentStyle={{ padding: 0, height: "100%" }}
				ref={modal}
				isVisible={showModal}
				hideClose={true}
				hideHeader={true}
				url={confirmUrl}
				style={{ width: 600, height: "100%", padding: 0 }}
				onClose={() => onConfirmModalClose()}
			/>
			<PaycardContainer>
				{paymentMethods.map((item) => (
					<PaycardCell
						key={"paycard-" + item.objectId}
						brand={item.brand}
						last4={item.last4}
						name={item.name}
						expDate={item.expDate ? item.expDate.iso : undefined}
						default={
							showAdd
								? false
								: applePaySelection
									? false
									: item.default
						}
						color={
							props.corporate &&
							props.corporate.color &&
							props.corporate.color.main
						}
						onClick={() => {
							setApplePaySelection(undefined);
							onPaymentMethodClick(item);
						}}
					/>
				))}
				{canUseApplePay && (
					<PaycardCell
						key={canUseApplePay}
						brand={canUseApplePay}
						last4={"Pay"}
						default={applePaySelection ? true : false}
						color={
							props.corporate &&
							props.corporate.color &&
							props.corporate.color.main
						}
						onClick={() => {
							setApplePaySelection(canUseApplePay);
						}}
					/>
				)}
				<Cell
					$isSelected={showAdd}
					onClick={() => setShowAdd(!showAdd)}
				>
					<Text
						type="p"
						style={{
							color: props.corporate?.color
								? props.corporate.color.main
								: ColorV2.text.primary,
							fontSize: 24,
							height: 36,
							borderRadius: 6,
							width: 36,
							backgroundColor: ColorV2.surface.neutralSoft,
							alignItems: "center",
							justifyContent: "center",
							display: "flex",
						}}
					>
						<CreditCard
							height={24}
							width={24}
							color={ColorV2.text.primary}
						/>
					</Text>
					<Text
						type="p"
						weight={showAdd ? "medium" : "regular"}
						style={{
							flex: 1,
							color: props.corporate?.color
								? props.corporate.color.main
								: ColorV2.text.primary,
							marginLeft: 16,
						}}
					>
						Añadir tarjeta
					</Text>
					<Selector
						$selected={showAdd}
						color={
							props.corporate?.color
								? props.corporate.color.main
								: ColorV2.text.primary
						}
					>
						{showAdd && (
							<Check
								strokeWidth={3}
								height={18}
								width={18}
								color={"white"}
							/>
						)}
					</Selector>
				</Cell>
				{showAdd && (
					<NewPaycardContainer>
						{canUseStripe ? (
							<Payout
								ref={payout}
								stripeKey={stripeKey}
								paymentOption={"card"}
								design={"secondary"}
							/>
						) : (
							<Col style={{ gap: 8 }}>
								<Input
									type="text"
									design="secondary"
									placeholder="Nombre del titular"
									LeftContent={
										<UserIcon
											style={{ marginRight: 8 }}
											height={18}
											width={18}
											color={ColorV2.border.neutralHigh}
										/>
									}
									onChange={(e) =>
										setIBAN({
											...IBAN,
											name: e.target.value,
										})
									}
								/>
								<Input
									type="text"
									design="secondary"
									placeholder="Número de cuenta bancaria"
									LeftContent={
										<Landmark
											style={{ marginRight: 8 }}
											height={18}
											width={18}
											color={ColorV2.border.neutralHigh}
										/>
									}
									onChange={(e) =>
										setIBAN({
											...IBAN,
											account: e.target.value,
										})
									}
								/>
							</Col>
						)}
					</NewPaycardContainer>
				)}
			</PaycardContainer>
		</SectionContainer>
	);
};
export default PaymentMethodStep;
export interface Props {
	user: UserScheme;
	view: string;
	paymentIntent?: Stripe.PaymentIntent;
	corporate?: CoorporateScheme;
	Footer?: ReactElement;
	onFinish: (result: { data?: string; error?: string }) => void;
	onProductChange?: (result: {
		data?: ProductScheme;
		error?: string;
	}) => void;
}
